import { nextTick } from 'vue'

/**
 * waits for Vue rerender and additional layout renders / shifts
 * @returns
 */
export const nextRender = () => {
	return new Promise<void>(async (resolve) => {
		await nextTick()
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					resolve()
				})
			})
		})
	})
}
